import { render, staticRenderFns } from "./SpaceNavigator.vue?vue&type=template&id=73dc21a6&scoped=true"
import script from "./SpaceNavigator.vue?vue&type=script&lang=js"
export * from "./SpaceNavigator.vue?vue&type=script&lang=js"
import style0 from "./SpaceNavigator.vue?vue&type=style&index=0&id=73dc21a6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc21a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73dc21a6')) {
      api.createRecord('73dc21a6', component.options)
    } else {
      api.reload('73dc21a6', component.options)
    }
    module.hot.accept("./SpaceNavigator.vue?vue&type=template&id=73dc21a6&scoped=true", function () {
      api.rerender('73dc21a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/availableSpaces/components/SpaceNavigator.vue"
export default component.exports